import { render, staticRenderFns } from "./category-list.vue?vue&type=template&id=2ef2c5d6&scoped=true"
import script from "./category-list.vue?vue&type=script&lang=js"
export * from "./category-list.vue?vue&type=script&lang=js"
import style0 from "./category-list.vue?vue&type=style&index=0&id=2ef2c5d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef2c5d6",
  null
  
)

export default component.exports